<div class="customers">
    <div class="row">
        <div class="col-sm-12">
            <div class="divActividad">
                <div class="row">
                   
                    <div class="col-sm-1">

                    </div>
                    <div class="col-sm-10">
                        <p class="dataFecha" style="margin: 20px;">ACTIVIDAD {{index + 1}}</p>
                    </div>
                    <div class="col-sm-1">
                        <button class="btn-collapser color-area-3" style="margin: 10px;" *ngIf="isCollapsed" alt="avatar" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                        <button class="btn-collapser color-area-3" style="margin: 10px;" *ngIf="!isCollapsed" alt="avatar" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                        <button class="btn-collapser color-area-3" style="margin: 10px;" *ngIf="index >= 1 && !readonly" (click)="eliminarActividad(index)"  ><i class="fas fa-trash"></i></button>
                    </div>
                    <div class="row" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" style=" margin-left: 5px;">
                        <div class="row">
                            <div class="col-sm-3">

                                <p class="dataFecha" style="margin: 20px;display: inline-block;">Nombre Actividad</p>
                                <button
                                    [ngbPopover]="popContentActividad"
                                    popoverTitle="Información de la Actividad"
                                    triggers="mouseenter:mouseleave"
                                    style="border: none; background-color: unset;"
                                    >
                                    <i class="fas fa-info-circle"></i>
                                </button>

                                <ng-template #popContentActividad>
                                    <ul>
                                        <li>Debe expresar clara y brevemente lo que se busca realizar.</li>
                                        <li>Debe ser consistente con el propósito del Plan.</li>
                                        <li>Las actividades deben responder a las necesidades identificadas en el diagnóstico y a las estrategias señaladas en la Rex 860.</li>
                                        <li>Se requiere planificar actividades para cada una de las estrategias.</li>
                                    </ul>
                                </ng-template>
                                 
                                <textarea class="text-area-consulta-estrategia" name="actividad" [(ngModel)]="actividad.actividad" [disabled]="readonly"  ></textarea>
                            </div>
                            <div class="col-sm-9">
                                <div class="row">
                                    <div class="col-sm-4" >
                                        <p class="dataFecha" style="margin: 20px;display: inline-block;">Objetivo </p>
                                        <button
                                            [ngbPopover]="popContentObjetivo"
                                            popoverTitle="Información del Objetivo"
                                            triggers="mouseenter:mouseleave"
                                            style="border: none; background-color: unset;"
                                            >
                                            <i class="fas fa-info-circle"></i>
                                        </button>
        
                                        <ng-template #popContentObjetivo>
                                            Constituye un desafío que expresa lo que la comunidad educativa
                                            espera alcanzar a través de la actividad propuesta para favorecer la
                                            buena convivencia.
                                            <ul>
                                                <li>La redacción debe comenzar con una acción que responda al “qué” se desea lograr.</li>
                                                <li>Deben ser expresados de manera cualitativa.</li>
                                                <li>Deben ser alcanzables.</li>
                                            </ul>
                                        </ng-template>
                                        <textarea class="text-area-consulta" name="objetivo" [(ngModel)]="actividad.objetivo" [disabled]="readonly" ></textarea>
                                    </div>
                                    <div class="col-sm-4" >
                                        <p class="dataFecha" style="margin: 20px;display: inline-block;">Descripción </p>
                                        <button
                                            [ngbPopover]="popContentDescripcion"
                                            popoverTitle="Información de la Descripción"
                                            triggers="mouseenter:mouseleave"
                                            style="border: none; background-color: unset;"
                                            >
                                            <i class="fas fa-info-circle"></i>
                                        </button>
        
                                        <ng-template #popContentDescripcion>
                                            Indicar brevemente en qué consiste la actividad y la manera en que la actividad contribuye al propósito del plan.
                                        </ng-template>
                                        <textarea class="text-area-consulta" name="descripcion" [(ngModel)]="actividad.descripcion" [disabled]="readonly" ></textarea>
                                    </div>
                                    <div class="col-sm-4" >
                                        <p class="dataFecha" style="margin: 20px;display: inline-block;">Lugar </p> 
                                        <button
                                            [ngbPopover]="popContentLugar"
                                            popoverTitle="Información del Lugar"
                                            triggers="mouseenter:mouseleave"
                                            style="border: none; background-color: unset;"
                                            >
                                            <i class="fas fa-info-circle"></i>
                                        </button>
        
                                        <ng-template #popContentLugar>
                                            Dónde se implementará la actividad.
                                        </ng-template>
                                        <textarea class="text-area-consulta" name="lugar" [(ngModel)]="actividad.lugar" [disabled]="readonly"></textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4" >
                                        <p class="dataFecha" style="margin: 20px;display: inline-block;">FECHA DE EJECUCIÓN </p> 
                                        <button
                                            [ngbPopover]="popContentFecha"
                                            popoverTitle="Información de la fecha de Ejecución"
                                            triggers="mouseenter:mouseleave"
                                            style="border: none; background-color: unset;"
                                            >
                                            <i class="fas fa-info-circle"></i>
                                        </button>
        
                                        <ng-template #popContentFecha>
                                            Plazo límite para la implementación de la actividad.
                                        </ng-template>
                                        <div class="row">
                                            <p class="dataFecha" style="margin: 1px;">Desde: </p> 
                                            <div class="input-group p-2">
                                                <div class="input-group-append">
                                                    <button class="btn btn-calendar" (click)="d1.toggle()" style="width: 40px;padding: 12px 12px;" type="button" [disabled]="readonly">
                                                        <i class="fas fa-calendar-alt"></i>
                                                    </button>
                                                </div>
                                                <input class="form-control input-fecha" [ngClass]="fechaClass" style="padding: 6px 12px;" name="fechaInicioMedicion" [(ngModel)]="this.fechaInicio" ngbDatepicker #d1="ngbDatepicker" (ngModelChange)="change()" readonly>
                                                <button class="btn btn-calendar-clear" (click)="clearDateInicio()" type="button" [disabled]="readonly"> 
                                                    <i class="fas fa-trash-alt"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <p class="dataFecha" style="margin: 1px;">Hasta: </p> 
                                            <div class="input-group p-2">
                                                <div class="input-group-append">
                                                    <button class="btn btn-calendar" (click)="d2.toggle()" style="width: 40px;padding: 12px 12px;" type="button" [disabled]="readonly"> 
                                                        <i class="fas fa-calendar-alt"></i>
                                                    </button>
                                                </div>
                                                <input class="form-control input-fecha" [ngClass]="fechaClass" style="padding: 6px 12px;" name="fechaFinMedicion" [(ngModel)]="this.fechaFin" ngbDatepicker #d2="ngbDatepicker" (ngModelChange)="change()" readonly>
                                                <button class="btn btn-calendar-clear" (click)="clearDateFin()" type="button" [disabled]="readonly"> 
                                                    <i class="fas fa-trash-alt"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4" >
                                        <p class="dataFecha" style="margin: 20px;display: inline-block;">Responsable de la Implementación </p> 
                                        <button
                                            [ngbPopover]="popContentResponsable"
                                            popoverTitle="Información del Responsable"
                                            triggers="mouseenter:mouseleave"
                                            style="border: none; background-color: unset;"
                                            >
                                            <i class="fas fa-info-circle"></i>
                                        </button>
        
                                        <ng-template #popContentResponsable>
                                            Quién o quiénes serán los encargados/as de realizar las gestiones para la implementación de la actividad.
                                        </ng-template>
                                        <textarea class="text-area-consulta" name="responsable" [(ngModel)]="actividad.responsable" [disabled]="readonly"></textarea>
                                    </div>
                                    <div class="col-sm-4" >
                                        <p class="dataFecha" style="margin: 20px;display: inline-block;">Medio de Verificación </p> 
                                        <button
                                        [ngbPopover]="popContentMedio"
                                        popoverTitle="Información del Medio de Verificación"
                                        triggers="mouseenter:mouseleave"
                                        style="border: none; background-color: unset;"
                                        >
                                        <i class="fas fa-info-circle"></i>
                                    </button>
    
                                    <ng-template #popContentMedio>
                                        Medio(s) a través del cual se acredita el cumplimiento de la actividad.
                                        Pueden comprometerse 1 o más verificadores, sugiriéndose aquellos
                                        que den cuenta de manera expresa de la ejecución de la actividad. Por
                                        ejemplo, Actas, Informes, Lista de asistencia, entre otros.
                                    </ng-template>
                                        <textarea class="text-area-consulta" name="medioVerificacion" [(ngModel)]="actividad.medioVerificacion" [disabled]="readonly"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>